import React, { useState } from "react";
import SalesReportFilter from "./SalesReportFilter";
import BillwiseReport from "./BillwiseReport";
import ItemwiseReport from "./ItemwiseReport";
import PartywisePurchaseReport from "./PartywisePurchaseReport";

import PurchaseBillwiseReport from "./PurchaseBillwiseReport";
import PurchaseItemwiseReport from "./PurchaseItemwiseReport";
import PurchasePartywiseReport from "./PurchasePartywiseReport";
import StockMovementReport from "./StockMovementReport";
import TaxReport from "./TaxReport";
import "./AllReports.css";

export default function AllReports() {

  // ===== GLOBAL DATE FILTER =====
  const today = new Date().toISOString().slice(0, 10);

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const [reportType, setReportType] = useState(null);
  const [activeTab, setActiveTab] = useState(null);

  // 🔹 Render Report Body
  const renderReport = () => {
    if (!reportType || !activeTab) return null;

    if (reportType === "SALES") {
      switch (activeTab) {
        case "COMMON":
          return <SalesReportFilter fromDate={fromDate} toDate={toDate} />;
        case "BILLWISE":
          return <BillwiseReport fromDate={fromDate} toDate={toDate} />;
        case "ITEMWISE":
          return <ItemwiseReport fromDate={fromDate} toDate={toDate} />;
        case "PARTYWISE":
          return <PartywisePurchaseReport fromDate={fromDate} toDate={toDate} />;
        default:
          return <SalesReportFilter fromDate={fromDate} toDate={toDate} />;
      }
    }

    if (reportType === "PURCHASE") {
      switch (activeTab) {
        case "BILLWISE":
          return <PurchaseBillwiseReport fromDate={fromDate} toDate={toDate} />;
        case "ITEMWISE":
          return <PurchaseItemwiseReport fromDate={fromDate} toDate={toDate} />;
        case "PARTYWISE":
          return <PurchasePartywiseReport fromDate={fromDate} toDate={toDate} />;
        default:
          return <PurchaseBillwiseReport fromDate={fromDate} toDate={toDate} />;
      }
    }

    if (reportType === "STOCK") {
      return <StockMovementReport fromDate={fromDate} toDate={toDate} />;
    }
if (reportType === "TAX") {
  return <TaxReport fromDate={fromDate} toDate={toDate} />;
}
    return null;
  };

  return (
    <div className="allreports-container">

      {/* MAIN HEADING */}
      <div className="allreports-title">
        ALL REPORTS
      </div>

      {/* MAIN TABS */}
      <div className="report-main-tabs">
        <div
          className={`main-tab ${reportType === "SALES" ? "active" : ""}`}
          onClick={() => {
            setReportType("SALES");
            setActiveTab("COMMON");
          }}
        >
          Sales
        </div>

        <div
          className={`main-tab ${reportType === "PURCHASE" ? "active" : ""}`}
          onClick={() => {
            setReportType("PURCHASE");
            setActiveTab("BILLWISE");
          }}
        >
          Purchase
        </div>

        <div
          className={`main-tab ${reportType === "STOCK" ? "active" : ""}`}
          onClick={() => {
            setReportType("STOCK");
            setActiveTab("MOVEMENT");
          }}
        >
          Stock
        </div>

        <div
  className={`main-tab ${reportType === "TAX" ? "active" : ""}`}
  onClick={() => {
    setReportType("TAX");
    setActiveTab("TAX");
  }}
>
  Tax
</div>
      </div>
{/* 🔹 LEVEL 2 HEADER */}
{reportType && (
  <>
    <div className="report-header-bar">

      {/* LEFT SIDE → SUB TABS */}
      <div className="report-tabs">

        {reportType === "SALES" && (
          <>
            <button
              className={activeTab === "COMMON" ? "active" : ""}
              onClick={() => setActiveTab("COMMON")}
            >
              Sales
            </button>

            <button
              className={activeTab === "BILLWISE" ? "active" : ""}
              onClick={() => setActiveTab("BILLWISE")}
            >
              Billwise
            </button>

            <button
              className={activeTab === "ITEMWISE" ? "active" : ""}
              onClick={() => setActiveTab("ITEMWISE")}
            >
              Itemwise
            </button>

            <button
              className={activeTab === "PARTYWISE" ? "active" : ""}
              onClick={() => setActiveTab("PARTYWISE")}
            >
              Partywise
            </button>
          </>
        )}

        {reportType === "PURCHASE" && (
          <>
            <button
              className={activeTab === "BILLWISE" ? "active" : ""}
              onClick={() => setActiveTab("BILLWISE")}
            >
              Billwise
            </button>

            <button
              className={activeTab === "ITEMWISE" ? "active" : ""}
              onClick={() => setActiveTab("ITEMWISE")}
            >
              Itemwise
            </button>

            <button
              className={activeTab === "PARTYWISE" ? "active" : ""}
              onClick={() => setActiveTab("PARTYWISE")}
            >
              Partywise
            </button>
          </>
        )}

        {reportType === "STOCK" && (
          <button
            className={activeTab === "MOVEMENT" ? "active" : ""}
            onClick={() => setActiveTab("MOVEMENT")}
          >
            Movement
          </button>
        )}

      </div>

      {/* RIGHT SIDE → DATE FILTER */}
 <div className="global-date-filter">

  <div className="date-box">
  
    <input
      type="date"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
    />
  </div>

  <div className="date-box">
 
    <input
      type="date"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
  </div>

</div>

    </div>

    <div className="report-body">
      {renderReport()}
    </div>
  </>
)}
</div>
  );
}